var TwoFactorAuthMethod;
(function (TwoFactorAuthMethod) {
  TwoFactorAuthMethod["GOOGLE_AUTHENTICATOR"] = "GOOGLE_AUTHENTICATOR";
  TwoFactorAuthMethod["SMS"] = "SMS";
  TwoFactorAuthMethod["BACKUP_CODE"] = "BACKUP_CODE";
  TwoFactorAuthMethod["HUBSPOT_AUTHENTICATOR"] = "HUBSPOT_AUTHENTICATOR";
})(TwoFactorAuthMethod || (TwoFactorAuthMethod = {}));
export default TwoFactorAuthMethod;